export default __webpack_public_path__ + "static/media/ACE-logo-soon.9cb91a6e.svg";